import { DiContainer } from '@/modules/di/di-container';
import { notification } from 'antd';
import { createEffect, createEvent, createStore, sample } from 'effector';
import { BuyerAccountOffersService } from '../services/buyer-account-offers.service';
import { IBuyerOffer, IBuyerOfferFromApi } from '../ts';

const buyerOffersService = DiContainer.get(BuyerAccountOffersService);

const setBuyerOffers = createEvent();
const setBuyerOffersLoadingStatus = createEvent<{
  loading: boolean;
  error: string | boolean | Error;
}>();

export const $buyerOffersLoadingStatus = createStore<{
  loading: boolean;
  error: string | boolean | Error | undefined;
}>({ loading: false, error: false }).on(setBuyerOffersLoadingStatus, (_s, p) => p);

export const $buyerOffers = createStore<IBuyerOfferFromApi[] | null>(null).on(setBuyerOffers, (_s, p) => p);
export const fetchBuyerOffersFx = createEffect(async () => {
  try {
    setBuyerOffersLoadingStatus({ loading: true, error: false });
    const res = await buyerOffersService.getAllOffers();
    setBuyerOffersLoadingStatus({ loading: false, error: false });
    // @ts-ignore
    return res.map(item => ({ ...item, wheat_type: item.type }));
  } catch (err) {
    setBuyerOffersLoadingStatus({ loading: false, error: err as Error });
  }
});

sample({ 
  target: setBuyerOffers, 
  clock: fetchBuyerOffersFx.doneData 
});

export const createBuyerOfferFx = createEffect(async(offerData: IBuyerOffer) => {
  try {
    const res = buyerOffersService.createNewOffer(offerData);
    return res
  } catch(err) { 
    throw err;
  }
});

export const updateBuyerOfferFx = createEffect(async(offerData: IBuyerOfferFromApi) => {
  try {
    const res = await buyerOffersService.updateOfferData(offerData);
    return res
  } catch(err) { 
    throw err;
  }
});

export const deleteBuyerOfferFx = createEffect(async(id: number) => {
  try {
    const res = await buyerOffersService.deleteOffer(id);
    return res
  } catch(err: any) { 
    const res = err.body && await err.json()
    return notification.error({ message: res.error || 'Возникла непредвиденная ошибка. Попробуйте, пожалуйста, позже.', })
  }
});
